import { useEffect, useState } from 'react'

interface UseDebouncedValueResult<T> {
  debouncedValue: T
  isDebouncing: boolean
}

export function useDebouncedValue<T>(value: T, delay: number): UseDebouncedValueResult<T> {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    if (Object.is(value, debouncedValue)) {
      return
    }

    const timeoutId = window.setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [debouncedValue, delay, value])

  return {
    debouncedValue,
    isDebouncing: !Object.is(value, debouncedValue),
  }
}
